<template>
  <div>
    <!-- 可编辑模式：上传按钮 + 表格 -->
    <template v-if="editable">
      <FileUpload @uploaded="handleUploaded">
        <a-button type="primary" icon="upload">上传附件</a-button>
      </FileUpload>
      <a-table
        v-if="fileList.length"
        bordered
        :data-source="fileList"
        :pagination="false"
        style="margin-top: 8px; width: 90%;"
        :rowKey="record => record.id || record.completePath"
      >
        <a-table-column title="文件名称">
          <template slot-scope="file">
            <template v-if="file.completePath">
              <a :href="file.completePath" target="_blank" @click="handleFileClick($event, file.completePath, file.name || getFileNameFromUrl(file.completePath))">
                {{ file.name || getFileNameFromUrl(file.completePath) }}
              </a>
            </template>
            <span v-else>{{ file.name || file.id }}</span>
          </template>
        </a-table-column>
        <a-table-column title="操作" width="80" align="center">
          <template slot-scope="file, record, index">
            <a style="color: #ff4d4f" @click="handleRemove(index)">删除</a>
          </template>
        </a-table-column>
      </a-table>
    </template>

    <!-- 只读模式：表格展示 -->
    <template v-else>
      <a-table
        v-if="readList.length"
        bordered
        :data-source="readList"
        :pagination="false"
        size="small"
        style="width: 90%;"
        :rowKey="(item, i) => i"
      >
        <a-table-column title="文件名称">
          <template slot-scope="record">
            <a v-if="record.path" :href="record.path" target="_blank" @click="handleFileClick($event, record.path, record.name || getFileNameFromUrl(record.path))">
              {{ record.name || getFileNameFromUrl(record.path) }}
            </a>
            <span v-else>-</span>
          </template>
        </a-table-column>
      </a-table>
      <span v-else>-</span>
    </template>
  </div>
</template>

<script>
import FileUpload from '@/components/file-upload'

export default {
  name: 'Attachment',
  components: { FileUpload },
  model: {
    prop: 'fileList',
    event: 'change'
  },
  props: {
    // 可编辑模式（上传+删除），只读模式（纯展示）
    editable: { type: Boolean, default: false },
    // 可编辑模式：对象数组 [{ id, name, completePath }]
    fileList: { type: Array, default: () => [] },
    // 只读模式：逗号分隔字符串 或 字符串数组
    value: { type: [String, Array], default: '' }
  },
  computed: {
    readList() {
      if (!this.value) return []
      if (Array.isArray(this.value)) {
        return this.value.filter(Boolean).map(item => {
          if (typeof item === 'string') return { path: item, name: '' }
          return { id:item.id,path: item.path || item.completePath || item.id, name: item.name || '' }
        })
      }
      if (typeof this.value === 'string') {
        try {
          const parsed = JSON.parse(this.value)
          if (Array.isArray(parsed)) {
            return parsed.filter(Boolean).map(item => ({
              id:item.id,
              path: item.completePath || item.path || item.id,
              name: item.name || ''
            }))
          }
        } catch { /* not a JSON string, fall through to comma-split */ }
        return this.value.split(',').filter(Boolean).map(path => ({ path, name: '' }))
      }
      return []
    }
  },
  data() {
    return {
    }
  },
  methods: {
    isPdfFile(filename) {
      return filename && filename.toLowerCase().endsWith('.pdf');
    },
    handleFileClick(event, url, filename) {
      if (this.isPdfFile(filename)) {
        event.preventDefault();
        this.previewPdf(url, filename);
      }
    },
    previewPdf(url, filename) {
      const routeUrl = this.$router.resolve({
        path: '/pdf-preview',
        query: { url, title: filename || 'PDF预览' }
      }).href;
      window.open(routeUrl, '_blank');
    },
    getFileNameFromUrl(url) {
      if (!url) return ''
      const str = String(url)
      const urlWithoutParams = str.split('?')[0]
      const fileName = urlWithoutParams.split('/').pop()
      return decodeURIComponent(fileName)
    },
    handleUploaded(list) {
        console.log("list::::",list)
      this.$emit('change', [...this.fileList, ...list])
    },
    handleRemove(index) {
      const newList = [...this.fileList]
      console.log("newList::::",newList)
      newList.splice(index, 1)
      this.$emit('change', newList)
    }
  }
}
</script>
